import { Props_SnippetHeading} from './Heading.props'
import { CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const SnippetHeading = (props: Props_SnippetHeading) => {
    const { heading } = props.snippet
    return (
        <section className='snippet-heading'>
            <div className='snippet-heading__heading'> 
                { CompileMarkdown(heading.value!) }
            </div>
        </section>
    )
}

export default SnippetHeading